import { render } from "./IconPackage.vue?vue&type=template&id=48c7a0ac"
import script from "./IconPackage.vue?vue&type=script&lang=ts"
export * from "./IconPackage.vue?vue&type=script&lang=ts"
script.render = render

export default script